export default "__VITE_ASSET__BnGf5wnb__"